
<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">

        <table #dataTable class="display" style="width:100%"></table>

        <button type="button" id="btn_AddNew" (click)="Show()" style="display:none">Add</button>
        <button type="button" id="btnDeleteDT" (click)="Delete()" style="display:none">Delete</button>
        <button type="button" id="btnInfoDT" (click)="Info()" style="display:none">Info</button>

        <button type="button" id="btnDeleteConfirm" (click)="DeleteConfirm()" style="display:none">Delete Confirm</button>
        <button type="button" id="btnDeleteActivity" (click)="DeleteActivity()" style="display:none">Delete Activity</button>
        <button type="button" id="btnCheckActivity" (click)="CheckActivity()" style="display:none">Check Activity</button>
        <button type="button" id="btnWorkflowType" (click)="ChangeWorkflowType()" style="display:none">Update Workflow Type</button>
        <button type="button" id="btnGetArticleIssues" (click)="GetArticleIssues()" style="display:none">GetArticleIssues</button>
        <button type="button" id="btnGetJournalsList" (click)="GetJournalsList()" style="display:none">GetJournalsList</button>
        <!--<button type="button" id="btnUploadDT" (click)="Upload()" style="display:none">Upload</button>
        <button type="button" id="btnDownloadDT" (click)="Download()" style="display:none">Download</button>-->
        <!--<button type="button" id="btnLink" (click)="LinkFile()" style="display:none">Link File</button>-->

        <button type="button" id="btnLoadList" (click)="GetWorkflowList()" style="display:none">Get</button>

        <div class="modal" [style.display]="showModal ? 'block' : 'none'">
          <div class="modal-dialog modal-xl custome-modal">
            <div class="modal-content workflowDetails" id="workflowDetails">
              <div class="modal-header">
                <h4 class="modal-title">{{title}}</h4>
                <!--<button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>-->
              </div>
              <div class="modal-body" style="overflow:visible!important">
                <div class="row">
                  <div class="col-sm-4">

                    <div class="col-sm-12">
                      Workflow Name<em>*</em>
                      <input id="Txt_WorkFlow" type="text" class="form-control" maxlength="40" value="{{workflowName}}" (change)="onSearchChange($event)" />
                    </div>
                    <div class="col-sm-12">
                      Description
                      <input id="Txt_Description" class="form-control" value="{{description}}">
                    </div>

                    <!--<div class="col-sm-3">
                      Publisher<em>*</em>
                      <select class="form-control select2" id="lstPublisher" onchange="$('#btnGetJournalsList').trigger('click');"></select>
                    </div>-->
                    <div class="col-sm-12">
                      Workflow Type
                      <select class="form-control" id="lstWorkflowType" onchange="$('#btnWorkflowType').trigger('click');">
                        <option value="Article">Article</option>
                        <option value="Issue">Issue</option>
                      </select>
                    </div>
                    <div class="col-sm-12">
                      Journal<em>*</em>
                      <select id="lstJournals" class="form-control" multiple onchange="$('#btnGetArticleIssues').trigger('click');">
                        <option *ngFor="let item of journalList" value={{item.ID}}>
                          {{item.Acronym}}
                        </option>
                      </select>
                    </div>
                    <div class="col-sm-12">
                      <div id="divArticleType">
                        Article Type
                        <select id="lstArticleTypes" class="form-control" multiple onchange="$('#btnGetArticleIssues').trigger('click');">
                          <option *ngFor="let item of articleTypeList" value={{item.SNo}}>
                            {{item.TypeName}}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <div style="display:none">
                        <div id="divArticle">
                          Article
                          <select id="lstArticles" class="form-control" multiple>
                            <option *ngFor="let item of articleList" value={{item.ID}}>
                              {{item.ArticleTitle}}
                            </option>
                          </select>
                        </div>
                        <div id="divIssue">
                          Issue
                          <select class="form-control" id="lstIssue">
                            <option *ngFor="let item of issueList" value={{item.ID}}>
                              {{item.Volume}}-{{item.Issue}} <!---{{item.IssueYear}}-->
                              on
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="col-sm-8">
                    <span id="spAddActivity" class="btn btn-outline-info waves-effect waves-light spAddActivity" (click)="AddActivity()">
                      <i class="fa fa-plus-square" aria-hidden="true"></i>
                    </span>
                    <div class="row">
                      <div class="col-sm-12">

                        <div class="col">
                          <div id="DivActivityList" class="activityTable fixTableHead">
                            <table id="tblAddWFList" class="table table-bordered table-head-fixed tblActivityList" data-select2-id="tblWFList">
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>Task</th>
                                  <th>Display Name</th>
                                  <th>Parallel</th>
                                  <th>Days</th>
                                  <th>Hours</th>
                                  <!--<th>File Action</th>-->
                                  <!--<th>Proofing Name<i class="fa fa-sort" aria-hidden="true"></i></th>
                                  <th>Stage<i class="fa fa-sort" aria-hidden="true"></i></th>
                                  <th>Upload/Download<i class="fa fa-sort" aria-hidden="true"></i></th>
                                  <th>Milestone<i class="fa fa-sort" aria-hidden="true"></i></th>-->
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer" style="position: fixed; bottom: 0; right: 0;">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" title="Update" id="btnWF" (click)="AddUpdateWorkFlow()">{{popUpButtonText}}</button>
              </div>
            </div>
          </div>

          <div id="LoadingImageReopen">
            <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
          </div>

        </div>

        <!--<div class="modal" [style.display]="infoModal ? 'block' : 'none'">
          <div class="modal-dialog modal-xl custome-modal">
            <div class="modal-content workflowInfo" id="workflowInfo">
              <div class="modal-header">
                <h4 class="modal-title">{{title}}</h4>-->
        <!--<button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>-->
        <!--</div>
        <div class="modal-body" style="overflow:visible!important;">-->
        <!---->
        <!--<div class="form-group">
          <div class="row">
            <div class="col-sm-6">
              Workflow Name<em>*</em>
              <input type="text" class="form-control" maxlength="40" value="{{workflowName}}" disabled />
            </div>
            <div class="col-sm-6">
              Description
              <input class="form-control" disabled value="{{description}}">
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">-->
        <!--<div class="col-sm-3">
          Publisher<em>*</em>
          <select class="form-control select2" id="Publisherlst" disabled></select>
        </div>-->
        <!--<div class="col-sm-3">
              Workflow Type
              <select id="WorkflowTypelst" class="form-control" disabled>
                <option value="Article">Article</option>
                <option value="Issue">Issue</option>
              </select>
            </div>
            <div class="col-sm-3">
              Journal<em>*</em>
              <select id="Journallst" class="form-control" multiple disabled>
                <option *ngFor="let item of journalList" value={{item.ID}}>
                  {{item.JournalTitle}}
                </option>
              </select>
            </div>
            <div class="col-sm-3">
              <div id="ArticleTypeDiv">
                Article Type
                <select id="ArticleTypelst" class="form-control select2" multiple disabled>
                  <option *ngFor="let item of articleTypeList" value={{item.SNo}}>
                    {{item.TypeName}}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm-3">
              <div id="ArticleDiv">
                Article
                <select id="Articlelst" class="form-control select2" multiple disabled> </select>
              </div>
              <div id="IssueDiv">
                Issue
                <select id="Issuelst" class="form-control select2" disabled></select>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-sm-12">
              <div id="DivActivityList" class="activityTable fixTableHead">
                <table id="tblWorkflowActivities" class="table table-bordered table-head-fixed tblActivityList" data-select2-id="tblWFList">
                  <thead >
                    <tr>
                      <th>#</th>
                      <th>Task</th>
                      <th>Display Name</th>
                      <th>Parallel</th>
                      <th>Days</th>
                      <th>Hours</th>-->
        <!--<th>File Action</th>-->
        <!--<th>Proofing Name<i class="fa fa-sort" aria-hidden="true"></i></th>
        <th>Stage<i class="fa fa-sort" aria-hidden="true"></i></th>
        <th>Upload/Download<i class="fa fa-sort" aria-hidden="true"></i></th>
        <th>Milestone<i class="fa fa-sort" aria-hidden="true"></i></th>-->
        <!--</tr>
                          </thead>
                          <tbody >
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer" style="position: fixed; bottom: 0; right: 0;">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
              </div>
            </div>
          </div>
        </div>-->

      </div>
    </div>
  </div>
</div>
